<template>
  <div :class="jel_getClassObject(content)">
    <div class="list-group">
      <!-- Titres du menu pied de page -->

      <div
        v-if="content.titre"
        :content="content.titre"
        class="liste-titre d-flex py-2 px-3 px-md-4"
        :class="[cssListGroupItem, jel_getClassObject(content)]"
        @click="isMenuPiedDePageOuvert = !isMenuPiedDePageOuvert"
      >
        <span class="p-0">
          {{ content.titre }}
        </span>
        <svg-icon
          class="d-md-none ml-auto mr-0"
          :class="{ rotation180: isMenuPiedDePageOuvert }"
          icon-name="fleche-bas"
        />
      </div>

      <WithRoot v-for="groupe in groupes" :key="groupe.id">
        <div class="col-12 p-0">
          <div class="w-100">
            <b-link
              v-if="content.montrerPlusMoins == 'true'"
              :key="groupe.listeItems[0].id"
              class="w-100"
              :class="[cssListGroupItem, jel_getClassObject(groupe.listeItems[0])]"
              v-bind="jel_getLienBinding(groupe.listeItems[0].lien)"
              @click="getPrefs(groupe.listeItems[0])"
            >
              <slot name="element" :itemElement="groupe.listeItems[0]"></slot>
            </b-link>
            <template
              v-if="
                (isMoreThanOneElement(groupe.listeItems) && isMenuGaucheOuvert) ||
                isMenuToutesCategories ||
                isMenuPiedDePage
              "
            >
              <template v-if="content.montrerPlusMoins == 'true'">
                <b-link
                  v-for="itemElement in groupe.listeItems.slice(1, 4)"
                  :key="itemElement.id"
                  :class="[cssTitreElement, jel_getClassObject(itemElement)]"
                  v-bind="jel_getLienBinding(itemElement.lien)"
                >
                  <slot name="element" :itemElement="itemElement"></slot>
                </b-link>
                <b-collapse
                  v-if="groupe.listeItems.length > 4"
                  :id="`collapse-${groupe.listeItems[0]['@id']}`"
                  :visible="getIsSectionMenuOuvert(groupe.listeItems[0]['@id'])"
                >
                  <b-link
                    v-for="itemElement in groupe.listeItems.slice(4)"
                    :key="itemElement.id"
                    :class="[cssTitreElement, jel_getClassObject(itemElement.lien)]"
                    v-bind="jel_getLienBinding(itemElement.lien)"
                  >
                    <slot name="element" :itemElement="itemElement"></slot>
                  </b-link>
                </b-collapse>
              </template>
              <!-- Menu de pied de page -->
              <template v-else>
                <span @click.capture="gaPreventClick">
                  <b-link
                    v-for="itemElement in groupe.listeItems"
                    :key="itemElement.id"
                    class="lien-bouton-menu"
                    :class="[cssListGroupItem, jel_getClassObject(itemElement)]"
                    v-bind="jel_getLienBinding(itemElement.lien)"
                  >
                    <slot name="element" :itemElement="itemElement"></slot>
                  </b-link>
                </span>
              </template>
            </template>
          </div>
          <button
            v-if="
              content.montrerPlusMoins == 'true' &&
              groupe.listeItems.length > 4 &&
              isMenuGaucheOuvert
            "
            :ref="`${groupe.listeItems[0]['@id']}`"
            class="col-12 montrer-plus-moins menu-ouvert"
            @click="setSectionMenuIsOuvert(`${groupe.listeItems[0]['@id']}`)"
          >
            <b-icon
              icon="chevron-down"
              aria-hidden="true"
              :class="{ rotation180: getIsSectionMenuOuvert(`${groupe.listeItems[0]['@id']}`) }"
            />
            <span class="sr-only">{{ $t('messageComponent.montrer') }}</span>
            {{
              getIsSectionMenuOuvert(groupe.listeItems[0]['@id'])
                ? $i18n.tc('messageComponent.plusMoins', 2)
                : $i18n.tc('messageComponent.plusMoins', 1)
            }}
            <span class="sr-only">
              {{ $t('messageComponent.de') }} {{ groupe.listeItems[0].item }}
            </span>
          </button>
        </div>
      </WithRoot>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import WithRoot from '@/components/base/WithRoot';

import { gtmCustomEventByVendor } from '@/helpers/ConsentHelpers';

export default {
  // eslint-disable-next-line vue/no-reserved-component-names
  name: 'Menu',
  components: { WithRoot },
  props: { content: { type: Object, required: true } },
  i18n: {
    messages: {
      fr: {
        messageComponent: {
          montrer: 'Montrer',
          plusMoins: 'Plus | Moins',
          de: 'de',
        },
      },
      en: {
        messageComponent: {
          montrer: 'Show',
          plusMoins: 'More | Less',
          de: 'of',
        },
      },
    },
  },
  data() {
    return {
      isMenuPiedDePageOuvert: false,
    };
  },
  computed: {
    ...mapGetters({
      getIsMenuGaucheOuvert: 'menu/getIsMenuGaucheOuvert',
      getIsSectionMenuOuvert: 'menu/getIsSectionMenuOuvert',
    }),
    isMenuGaucheOuvert() {
      if (this.getIsMenuGaucheOuvert !== null) return this.getIsMenuGaucheOuvert;
      return this.$mq == 'xl' || this.$mq == 'xxl';
    },
    listeItems() {
      const itemsFiltre = [];
      this.content.listeItems['@nodes'].forEach((item) => {
        itemsFiltre.push(this.content.listeItems[item]);
      });
      return itemsFiltre;
    },
    groupes() {
      const listeGroupes = [];
      if (this.content.montrerPlusMoins == 'true') {
        let itemsGroupe = [];
        for (let i = 0; i < this.listeItems.length; i++) {
          itemsGroupe.push(this.listeItems[i]);
          if (!this.listeItems[i + 1] || this.isTitre(this.listeItems[i + 1])) {
            listeGroupes.push({ listeItems: itemsGroupe });
            itemsGroupe = [];
          }
        }
      } else {
        listeGroupes.push({ listeItems: this.listeItems });
      }
      return listeGroupes;
    },
    isMenuToutesCategories() {
      return this.content.menuCategories;
    },
    isMenuPiedDePage() {
      return this.content.menuPiedDePage;
    },
    cssListGroupItem() {
      if (this.isMenuToutesCategories) {
        return 'list-group-item-categories';
      }
      return 'list-group-item';
    },
    cssTitreElement(item) {
      let classeCSS = this.isTitre(item) ? 'liste-titre' : '';
      classeCSS += ` ${this.cssListGroupItem}`;
      return classeCSS;
    },
  },
  methods: {
    ...mapActions({
      setSectionMenuIsOuvert: 'menu/setSectionMenuIsOuvert',
    }),
    getPrefs(item) {
      if (item.specialite === 'favoris' || item.specialite === 'jouesRecemment') {
        this.$store.dispatch('preferences/getPreferences');
      }
    },
    gaPreventClick(evt = null) {
      if (this.isMenuToutesCategories) {
        const event = 'ga-mtc-click';
        const categorie = 'MTC - Menu toutes catégories';
        const libelle = `Catégorie${evt.target.textContent}`;
        // Ajout datalayer pour ajouter statistiques Event click vers Google Analytics
        gtmCustomEventByVendor(process.env.VUE_APP_IAB_ID_ANALYTICS, {
          event,
          categorie,
          emplacement: `${this.jel_gaGetEmplacement()}`,
          libelle,
        });
      } else if (this.isMenuPiedDePage) {
        const event = 'ga-pp-click';
        const categorie = 'PP - Pied de Page';
        const libelle = `Lien ${evt.target.textContent}`;

        // Ajout datalayer pour ajouter statistiques Event click vers Google Analytics
        gtmCustomEventByVendor(process.env.VUE_APP_IAB_ID_ANALYTICS, {
          event,
          categorie,
          emplacement: `${this.jel_gaGetEmplacement()}`,
          libelle,
        });
      }
    },

    isTitre(item) {
      return item.image;
    },
    isMoreThanOneElement(item) {
      return item.length > 1;
    },
  },
};
</script>

<style lang="scss" scoped>
div.list-group .list-group-item {
  border: none;
  color: $couleur-bleu-fonce-lq;
  font-family: graphik_medium;
  &:hover {
    text-decoration: none;
  }
}
div.list-group .list-group-item-categories {
  border: none;
  color: $couleur-bleu-fonce-lq;
  font-family: graphik_medium;
  white-space: nowrap;
  display: block;
  position: relative;
  padding: 0 1rem;
  text-decoration: none;
  &:hover {
    background-color: $blanc-casino;
  }
  &:focus-visible {
    background-color: $bleu-pale-casino;
    outline: none;
  }
}

.montrer-plus-moins {
  background-color: transparent;
  border: none;
  display: flex;
  font-size: 0.9125rem;
  padding: 0.5rem 0;
  &:hover {
    background-color: $couleur-fond-primaire;
  }
  &:focus-visible {
    outline: none;
    background-color: $bleu-pale-casino;
  }
}

.fleche-titre {
  @include media-breakpoint-up(md) {
    display: none !important;
  }
}

div::v-deep svg {
  color: $couleur-primaire-bouton-theme-clair;
  height: 20px;
  width: 15px;
  margin-left: 1.25rem;
  margin-right: 1.3rem;
  object-fit: contain;
}
</style>
